<template>
  <div class="c-link-list__item">
    <sc-link
      v-if="fields && fields.link"
      :field="fields.link"
      class="c-link-list__link"
      :class="fields.link.value.class"
    />
    <sc-text
      v-if="fields && fields.description"
      :field="fields.description"
      class="c-link-list__desc"
    />
  </div>
</template>

<script>
import { Link, Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Link',
  components: {
    ScLink: Link,
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
